import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from './commands-core'

export function useCreateProjectPhaseDefinitionCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	id?: string | Ref<string> | (() => string), 
	projectPhaseDefinitionId?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	prevPhaseId?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectPhaseDefinitionId = isRef<string>(projectPhaseDefinitionId) ? projectPhaseDefinitionId : ref<string>((typeof projectPhaseDefinitionId === 'function') ? projectPhaseDefinitionId() : projectPhaseDefinitionId)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _prevPhaseId = isRef<string>(prevPhaseId) ? prevPhaseId : ref<string>((typeof prevPhaseId === 'function') ? prevPhaseId() : prevPhaseId)

	const result = {
		workspaceId: _workspaceId,
		id: _id,
		projectPhaseDefinitionId: _projectPhaseDefinitionId,
		name: _name,
		prevPhaseId: _prevPhaseId,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectPhaseDefinitionId === 'function') { _projectPhaseDefinitionId.value = projectPhaseDefinitionId() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof prevPhaseId === 'function') { _prevPhaseId.value = prevPhaseId() }

			return new c.CreateProjectPhaseDefinitionCommandV1(_workspaceId.value, _id.value, _projectPhaseDefinitionId.value, _name.value, _prevPhaseId.value)
		})
	}

	return {
		...result,
		authorizedCreateProjectPhaseDefinitionCommandV1: result.authorized,
		createProjectPhaseDefinitionCommandV1: result.command,
		completedCreateProjectPhaseDefinitionCommandV1: result.completed,
		errorCreateProjectPhaseDefinitionCommandV1: result.error,
		invokeCreateProjectPhaseDefinitionCommandV1: result.invoke,
		invokingCreateProjectPhaseDefinitionCommandV1: result.invoking,
		succeedCreateProjectPhaseDefinitionCommandV1: result.succeed,
		validationErrorsCreateProjectPhaseDefinitionCommandV1: result.validationErrors,
		onSucceedCreateProjectPhaseDefinitionCommandV1: result.onSucceed,
	}
}

export function useCreateStrategyCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)

	const result = {
		workspaceId: _workspaceId,
		id: _id,
		name: _name,
		description: _description,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }

			return new c.CreateStrategyCommandV1(_workspaceId.value, _id.value, _name.value, _description.value)
		})
	}

	return {
		...result,
		authorizedCreateStrategyCommandV1: result.authorized,
		createStrategyCommandV1: result.command,
		completedCreateStrategyCommandV1: result.completed,
		errorCreateStrategyCommandV1: result.error,
		invokeCreateStrategyCommandV1: result.invoke,
		invokingCreateStrategyCommandV1: result.invoking,
		succeedCreateStrategyCommandV1: result.succeed,
		validationErrorsCreateStrategyCommandV1: result.validationErrors,
		onSucceedCreateStrategyCommandV1: result.onSucceed,
	}
}

export function useDeleteProjectPhaseDefinitionCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	id?: string | Ref<string> | (() => string), 
	projectPhaseDefinitionId?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectPhaseDefinitionId = isRef<string>(projectPhaseDefinitionId) ? projectPhaseDefinitionId : ref<string>((typeof projectPhaseDefinitionId === 'function') ? projectPhaseDefinitionId() : projectPhaseDefinitionId)

	const result = {
		workspaceId: _workspaceId,
		id: _id,
		projectPhaseDefinitionId: _projectPhaseDefinitionId,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectPhaseDefinitionId === 'function') { _projectPhaseDefinitionId.value = projectPhaseDefinitionId() }

			return new c.DeleteProjectPhaseDefinitionCommandV1(_workspaceId.value, _id.value, _projectPhaseDefinitionId.value)
		})
	}

	return {
		...result,
		authorizedDeleteProjectPhaseDefinitionCommandV1: result.authorized,
		deleteProjectPhaseDefinitionCommandV1: result.command,
		completedDeleteProjectPhaseDefinitionCommandV1: result.completed,
		errorDeleteProjectPhaseDefinitionCommandV1: result.error,
		invokeDeleteProjectPhaseDefinitionCommandV1: result.invoke,
		invokingDeleteProjectPhaseDefinitionCommandV1: result.invoking,
		succeedDeleteProjectPhaseDefinitionCommandV1: result.succeed,
		validationErrorsDeleteProjectPhaseDefinitionCommandV1: result.validationErrors,
		onSucceedDeleteProjectPhaseDefinitionCommandV1: result.onSucceed,
	}
}

export function useDeleteStrategyCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.DeleteStrategyCommandV1(_workspaceId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedDeleteStrategyCommandV1: result.authorized,
		deleteStrategyCommandV1: result.command,
		completedDeleteStrategyCommandV1: result.completed,
		errorDeleteStrategyCommandV1: result.error,
		invokeDeleteStrategyCommandV1: result.invoke,
		invokingDeleteStrategyCommandV1: result.invoking,
		succeedDeleteStrategyCommandV1: result.succeed,
		validationErrorsDeleteStrategyCommandV1: result.validationErrors,
		onSucceedDeleteStrategyCommandV1: result.onSucceed,
	}
}

export function useRenameProjectPhaseDefinitionCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	id?: string | Ref<string> | (() => string), 
	projectPhaseDefinitionId?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectPhaseDefinitionId = isRef<string>(projectPhaseDefinitionId) ? projectPhaseDefinitionId : ref<string>((typeof projectPhaseDefinitionId === 'function') ? projectPhaseDefinitionId() : projectPhaseDefinitionId)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)

	const result = {
		workspaceId: _workspaceId,
		id: _id,
		projectPhaseDefinitionId: _projectPhaseDefinitionId,
		name: _name,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectPhaseDefinitionId === 'function') { _projectPhaseDefinitionId.value = projectPhaseDefinitionId() }
			if (typeof name === 'function') { _name.value = name() }

			return new c.RenameProjectPhaseDefinitionCommandV1(_workspaceId.value, _id.value, _projectPhaseDefinitionId.value, _name.value)
		})
	}

	return {
		...result,
		authorizedRenameProjectPhaseDefinitionCommandV1: result.authorized,
		renameProjectPhaseDefinitionCommandV1: result.command,
		completedRenameProjectPhaseDefinitionCommandV1: result.completed,
		errorRenameProjectPhaseDefinitionCommandV1: result.error,
		invokeRenameProjectPhaseDefinitionCommandV1: result.invoke,
		invokingRenameProjectPhaseDefinitionCommandV1: result.invoking,
		succeedRenameProjectPhaseDefinitionCommandV1: result.succeed,
		validationErrorsRenameProjectPhaseDefinitionCommandV1: result.validationErrors,
		onSucceedRenameProjectPhaseDefinitionCommandV1: result.onSucceed,
	}
}

export function useSaveViewAllProjectsPageCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	id?: string | Ref<string> | (() => string), 
	grid?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _grid = isRef<string>(grid) ? grid : ref<string>((typeof grid === 'function') ? grid() : grid)

	const result = {
		workspaceId: _workspaceId,
		id: _id,
		grid: _grid,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof grid === 'function') { _grid.value = grid() }

			return new c.SaveViewAllProjectsPageCommandV1(_workspaceId.value, _id.value, _grid.value)
		})
	}

	return {
		...result,
		authorizedSaveViewAllProjectsPageCommandV1: result.authorized,
		saveViewAllProjectsPageCommandV1: result.command,
		completedSaveViewAllProjectsPageCommandV1: result.completed,
		errorSaveViewAllProjectsPageCommandV1: result.error,
		invokeSaveViewAllProjectsPageCommandV1: result.invoke,
		invokingSaveViewAllProjectsPageCommandV1: result.invoking,
		succeedSaveViewAllProjectsPageCommandV1: result.succeed,
		validationErrorsSaveViewAllProjectsPageCommandV1: result.validationErrors,
		onSucceedSaveViewAllProjectsPageCommandV1: result.onSucceed,
	}
}

export function useSaveViewFinishedProjectsPageCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	id?: string | Ref<string> | (() => string), 
	grid?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _grid = isRef<string>(grid) ? grid : ref<string>((typeof grid === 'function') ? grid() : grid)

	const result = {
		workspaceId: _workspaceId,
		id: _id,
		grid: _grid,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof grid === 'function') { _grid.value = grid() }

			return new c.SaveViewFinishedProjectsPageCommandV1(_workspaceId.value, _id.value, _grid.value)
		})
	}

	return {
		...result,
		authorizedSaveViewFinishedProjectsPageCommandV1: result.authorized,
		saveViewFinishedProjectsPageCommandV1: result.command,
		completedSaveViewFinishedProjectsPageCommandV1: result.completed,
		errorSaveViewFinishedProjectsPageCommandV1: result.error,
		invokeSaveViewFinishedProjectsPageCommandV1: result.invoke,
		invokingSaveViewFinishedProjectsPageCommandV1: result.invoking,
		succeedSaveViewFinishedProjectsPageCommandV1: result.succeed,
		validationErrorsSaveViewFinishedProjectsPageCommandV1: result.validationErrors,
		onSucceedSaveViewFinishedProjectsPageCommandV1: result.onSucceed,
	}
}

export function useSaveViewProposedProjectsPageCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	id?: string | Ref<string> | (() => string), 
	grid?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _grid = isRef<string>(grid) ? grid : ref<string>((typeof grid === 'function') ? grid() : grid)

	const result = {
		workspaceId: _workspaceId,
		id: _id,
		grid: _grid,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof grid === 'function') { _grid.value = grid() }

			return new c.SaveViewProposedProjectsPageCommandV1(_workspaceId.value, _id.value, _grid.value)
		})
	}

	return {
		...result,
		authorizedSaveViewProposedProjectsPageCommandV1: result.authorized,
		saveViewProposedProjectsPageCommandV1: result.command,
		completedSaveViewProposedProjectsPageCommandV1: result.completed,
		errorSaveViewProposedProjectsPageCommandV1: result.error,
		invokeSaveViewProposedProjectsPageCommandV1: result.invoke,
		invokingSaveViewProposedProjectsPageCommandV1: result.invoking,
		succeedSaveViewProposedProjectsPageCommandV1: result.succeed,
		validationErrorsSaveViewProposedProjectsPageCommandV1: result.validationErrors,
		onSucceedSaveViewProposedProjectsPageCommandV1: result.onSucceed,
	}
}

export function useSaveViewScheduledProjectsPageCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	id?: string | Ref<string> | (() => string), 
	grid?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _grid = isRef<string>(grid) ? grid : ref<string>((typeof grid === 'function') ? grid() : grid)

	const result = {
		workspaceId: _workspaceId,
		id: _id,
		grid: _grid,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof grid === 'function') { _grid.value = grid() }

			return new c.SaveViewScheduledProjectsPageCommandV1(_workspaceId.value, _id.value, _grid.value)
		})
	}

	return {
		...result,
		authorizedSaveViewScheduledProjectsPageCommandV1: result.authorized,
		saveViewScheduledProjectsPageCommandV1: result.command,
		completedSaveViewScheduledProjectsPageCommandV1: result.completed,
		errorSaveViewScheduledProjectsPageCommandV1: result.error,
		invokeSaveViewScheduledProjectsPageCommandV1: result.invoke,
		invokingSaveViewScheduledProjectsPageCommandV1: result.invoking,
		succeedSaveViewScheduledProjectsPageCommandV1: result.succeed,
		validationErrorsSaveViewScheduledProjectsPageCommandV1: result.validationErrors,
		onSucceedSaveViewScheduledProjectsPageCommandV1: result.onSucceed,
	}
}

export function useSaveViewStartedProjectsPageCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	id?: string | Ref<string> | (() => string), 
	grid?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _grid = isRef<string>(grid) ? grid : ref<string>((typeof grid === 'function') ? grid() : grid)

	const result = {
		workspaceId: _workspaceId,
		id: _id,
		grid: _grid,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof grid === 'function') { _grid.value = grid() }

			return new c.SaveViewStartedProjectsPageCommandV1(_workspaceId.value, _id.value, _grid.value)
		})
	}

	return {
		...result,
		authorizedSaveViewStartedProjectsPageCommandV1: result.authorized,
		saveViewStartedProjectsPageCommandV1: result.command,
		completedSaveViewStartedProjectsPageCommandV1: result.completed,
		errorSaveViewStartedProjectsPageCommandV1: result.error,
		invokeSaveViewStartedProjectsPageCommandV1: result.invoke,
		invokingSaveViewStartedProjectsPageCommandV1: result.invoking,
		succeedSaveViewStartedProjectsPageCommandV1: result.succeed,
		validationErrorsSaveViewStartedProjectsPageCommandV1: result.validationErrors,
		onSucceedSaveViewStartedProjectsPageCommandV1: result.onSucceed,
	}
}

export function useTriggerMetricUpdatesCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.TriggerMetricUpdatesCommandV1(_workspaceId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedTriggerMetricUpdatesCommandV1: result.authorized,
		triggerMetricUpdatesCommandV1: result.command,
		completedTriggerMetricUpdatesCommandV1: result.completed,
		errorTriggerMetricUpdatesCommandV1: result.error,
		invokeTriggerMetricUpdatesCommandV1: result.invoke,
		invokingTriggerMetricUpdatesCommandV1: result.invoking,
		succeedTriggerMetricUpdatesCommandV1: result.succeed,
		validationErrorsTriggerMetricUpdatesCommandV1: result.validationErrors,
		onSucceedTriggerMetricUpdatesCommandV1: result.onSucceed,
	}
}

export function useUpdateResourceUnitCostsCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	id?: string | Ref<string> | (() => string), 
	fromYear?: number | Ref<number> | (() => number), 
	entries?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _fromYear = isRef<number>(fromYear) ? fromYear : ref<number>((typeof fromYear === 'function') ? fromYear() : fromYear)
	const _entries = isRef<any>(entries) ? entries : ref<any>((typeof entries === 'function') ? entries() : entries)

	const result = {
		workspaceId: _workspaceId,
		id: _id,
		fromYear: _fromYear,
		entries: _entries,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof fromYear === 'function') { _fromYear.value = fromYear() }
			if (typeof entries === 'function') { _entries.value = entries() }

			return new c.UpdateResourceUnitCostsCommandV1(_workspaceId.value, _id.value, _fromYear.value, _entries.value)
		})
	}

	return {
		...result,
		authorizedUpdateResourceUnitCostsCommandV1: result.authorized,
		updateResourceUnitCostsCommandV1: result.command,
		completedUpdateResourceUnitCostsCommandV1: result.completed,
		errorUpdateResourceUnitCostsCommandV1: result.error,
		invokeUpdateResourceUnitCostsCommandV1: result.invoke,
		invokingUpdateResourceUnitCostsCommandV1: result.invoking,
		succeedUpdateResourceUnitCostsCommandV1: result.succeed,
		validationErrorsUpdateResourceUnitCostsCommandV1: result.validationErrors,
		onSucceedUpdateResourceUnitCostsCommandV1: result.onSucceed,
	}
}

export function useUpdateStrategySettingsCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	currency?: string | Ref<string> | (() => string), 
	defaultPnlId?: string | Ref<string> | (() => string), 
	includeCogs?: boolean | Ref<boolean> | (() => boolean), 
	includeOpex?: boolean | Ref<boolean> | (() => boolean), 
	includeOther?: boolean | Ref<boolean> | (() => boolean), 
	fiscalYearStartMonth?: number | Ref<number> | (() => number), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _currency = isRef<string>(currency) ? currency : ref<string>((typeof currency === 'function') ? currency() : currency)
	const _defaultPnlId = isRef<string>(defaultPnlId) ? defaultPnlId : ref<string>((typeof defaultPnlId === 'function') ? defaultPnlId() : defaultPnlId)
	const _includeCogs = isRef<boolean>(includeCogs) ? includeCogs : ref<boolean>((typeof includeCogs === 'function') ? includeCogs() : includeCogs)
	const _includeOpex = isRef<boolean>(includeOpex) ? includeOpex : ref<boolean>((typeof includeOpex === 'function') ? includeOpex() : includeOpex)
	const _includeOther = isRef<boolean>(includeOther) ? includeOther : ref<boolean>((typeof includeOther === 'function') ? includeOther() : includeOther)
	const _fiscalYearStartMonth = isRef<number>(fiscalYearStartMonth) ? fiscalYearStartMonth : ref<number>((typeof fiscalYearStartMonth === 'function') ? fiscalYearStartMonth() : fiscalYearStartMonth)

	const result = {
		workspaceId: _workspaceId,
		id: _id,
		name: _name,
		description: _description,
		currency: _currency,
		defaultPnlId: _defaultPnlId,
		includeCogs: _includeCogs,
		includeOpex: _includeOpex,
		includeOther: _includeOther,
		fiscalYearStartMonth: _fiscalYearStartMonth,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof currency === 'function') { _currency.value = currency() }
			if (typeof defaultPnlId === 'function') { _defaultPnlId.value = defaultPnlId() }
			if (typeof includeCogs === 'function') { _includeCogs.value = includeCogs() }
			if (typeof includeOpex === 'function') { _includeOpex.value = includeOpex() }
			if (typeof includeOther === 'function') { _includeOther.value = includeOther() }
			if (typeof fiscalYearStartMonth === 'function') { _fiscalYearStartMonth.value = fiscalYearStartMonth() }

			return new c.UpdateStrategySettingsCommandV1(_workspaceId.value, _id.value, _name.value, _description.value, _currency.value, _defaultPnlId.value, _includeCogs.value, _includeOpex.value, _includeOther.value, _fiscalYearStartMonth.value)
		})
	}

	return {
		...result,
		authorizedUpdateStrategySettingsCommandV1: result.authorized,
		updateStrategySettingsCommandV1: result.command,
		completedUpdateStrategySettingsCommandV1: result.completed,
		errorUpdateStrategySettingsCommandV1: result.error,
		invokeUpdateStrategySettingsCommandV1: result.invoke,
		invokingUpdateStrategySettingsCommandV1: result.invoking,
		succeedUpdateStrategySettingsCommandV1: result.succeed,
		validationErrorsUpdateStrategySettingsCommandV1: result.validationErrors,
		onSucceedUpdateStrategySettingsCommandV1: result.onSucceed,
	}
}

